import type { Answers } from '../types/application';
import { loanOfficer, processor } from '../data/team';
import { subscriber } from '../data/subscriber';

export type Tokens = Record<string, string>;

// Replaces {{token}} placeholders. Unknown tokens are left visible so gaps are obvious.
export function fillTemplate(template: string, tokens: Tokens): string {
  return template.replace(/\{\{(\w+)\}\}/g, (match, key: string) => tokens[key] ?? match);
}

export function buildTokens(a: Answers): Tokens {
  const currentEmployer = a.employers.find((e) => !e.endDate) ?? a.employers[0];
  const primaryAccount = a.assets.find((x) => x.type === 'checking') ?? a.assets[0];
  return {
    brokerCompanyName: subscriber.companyName,
    brokerShortName: subscriber.companyShortName,
    brokerNmls: subscriber.companyNmls,
    brokerLicensing: subscriber.licensing,
    loanOfficerName: loanOfficer.name,
    loanOfficerFirstName: loanOfficer.firstName,
    processorName: processor.name,
    processorFirstName: processor.firstName,
    borrowerFirstName: a.firstName,
    propertyStreet: a.propertyStreet || 'your new home',
    propertyState: a.propertyState,
    employerName: currentEmployer?.name || 'your employer',
    primaryAccountName: primaryAccount?.institution || 'your bank',
  };
}
